import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
const AUTH_API = environment.apiUrl;
const httpOptions = {
  headers: new HttpHeaders({
   "enctype": "multipart/form-data"
  })
};
@Injectable({
  providedIn: 'root',
})

export class PiteamService {
  constructor(private http: HttpClient) { }
  _profileEdit = false;
  _createUsersComponent: any;
  _currentDate = "";
  _currentTime: any;
  currentDateTime() {
    var data;
    var today = new Date();
    this._currentTime = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    today.toLocaleString('it-IT', { month: 'long' });
    data = today.toString();
    data = data.split(' ');
    this._currentDate = data[1].concat(' ').concat(data[2]).concat(',').concat(data[3]);
  }
  GetAllUsers(obj: any, systemKey: any, roleName: any, userId: any) {
    return this.http.post(AUTH_API + `/Users/GetUsers?systemKey=${systemKey}&roleName=${roleName}&userId=${userId}`, obj);
  }
  CreateUser(obj: any, UId: any, UName: any) {
    return this.http.post(AUTH_API + '/Users/AddUser', obj, {
      params: {
        createdBy: UId,
        createdByName: UName
      }
    });
  }
  UpdateUser(obj: any) {
    return this.http.post(AUTH_API + '/Users/EditUser',obj);
  }

  UploadProfileImageOnSave(formData: FormData) {
    return this.http.post(AUTH_API + '/Users/UploadProfileImageOnSave',formData, httpOptions);
  }

  GetUserDetailById(userId: any) {
    return this.http.get(AUTH_API + '/Users/GetUserDetailById?userid=' + userId);
  }
  GetAllStatesAndRoles() {
    return this.http.get(AUTH_API + '/Users/GetAllStatesAndRoles');
  }
  AssignRole(model: any,) {
    return this.http.post(AUTH_API + '/Users/AddUserRoles', model);
  }
  GetUsersWithRoles(obj: any, systemKey: any, roleName: any, userId: any) {
    return this.http.post(AUTH_API + `/Users/GetUsersWithRoles?systemKey=${systemKey}&roleName=${roleName}&userId=${userId}`, obj);
  }
  GetUsersForRole() {
    return this.http.get(AUTH_API + '/api/Users');
  }
  GetFacilityBySystem(systemId: any) {
    return this.http.get(AUTH_API + '/Users/GetUserDetailById?userid=' + systemId);
  }
  GetAssignedFacilityInfo(model: any,) {
    return this.http.post(AUTH_API + '/Users/GetAssignedFacilityInfo', model);
  }
}
